var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 5,
    height: 8,
    viewBox: "0 0 5 8",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.222864 3.49346C0.080164 3.62781 0 3.81002 0 4C0 4.18998 0.080164 4.37219 0.222864 4.50654L3.71898 7.79729C3.86078 7.92809 4.0517 8.00093 4.25023 7.99999C4.44877 7.99905 4.63889 7.92439 4.77928 7.79225C4.91967 7.66011 4.99899 7.48115 4.99999 7.29428C5.00099 7.1074 4.9236 6.9277 4.78464 6.79423L1.81602 4L4.78464 1.20577C4.9236 1.0723 5.00099 0.892599 4.99999 0.705723C4.99899 0.518847 4.91967 0.339893 4.77928 0.20775C4.63889 0.0756075 4.44877 0.000952901 4.25023 9.05896e-06C4.0517 -0.000934783 3.86078 0.0719085 3.71898 0.20271L0.222864 3.49346Z",
    fill: "#0044CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft);
export default __webpack_public_path__ + "static/media/left.80cb030965c71dcfbf9a92d42e33c44c.svg";
export { ForwardRef as ReactComponent };